import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { addCategory, getGuideCategoryToBoats, selectAddCategoryLoading } from "store/boats"

/**
 * Custom hook for managing inline category creation and search
 */
export const useCategoryManagement = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [search, setSearch] = useState("")
  const [showAddForm, setShowAddForm] = useState(false)
  const [name, setName] = useState("")
  const [error, setError] = useState("")
  const isLoading = useSelector(selectAddCategoryLoading)

  const reset = () => {
    setShowAddForm(false)
    setName("")
    setError("")
  }

  const handleAdd = async () => {
    const trimmed = name.trim()
    if (!trimmed) {
      setError(t("equipment.please_enter_category_name"))
      return
    }
    try {
      const result = await dispatch(addCategory({ name: trimmed }))
      dispatch(getGuideCategoryToBoats())
      reset()
      return result?.id
    } catch (error) {
      const errorData = error?.data
      const msg =
        (Array.isArray(errorData?.errors) && errorData.errors[0]) ||
        errorData?.message ||
        errorData?.error ||
        t("equipment.failed_to_add_category", { defaultValue: "Failed to add category" })
      setError(msg)
      throw error
    }
  }

  const handleClearError = () => error && setError("")

  return {
    search,
    setSearch,
    showAddForm,
    setShowAddForm,
    name,
    setName,
    error,
    setError,
    isLoading,
    reset,
    handleAdd,
    handleClearError
  }
}
